import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import '@mdi/font/css/materialdesignicons.min.css';
import AuthenticationModal from './authentication/authenticationModal.vue';
import i18n from './i18n';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {formatNumberCeisa, formatQty, formatCurrency, roundDecimal} from "./helpers/formatData/number";
import {formatDate, formatDateTime} from "./helpers/formatData/date";

Vue.config.productionTip = false;

// Daftarkan helper secara global di Vue 2
Vue.prototype.$formatNumberCeisa = formatNumberCeisa;
Vue.prototype.$formatQty = formatQty;
Vue.prototype.$formatCurrency = formatCurrency;
Vue.prototype.$roundDecimal = roundDecimal;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$formatDateTime = formatDateTime;


Vue.component("v-select", vSelect);

// Pastikan bahasa selalu pakai dari localStorage
const lang = localStorage.getItem('user-lang') || 'id';
i18n.locale = lang;

// Register modal globally
Vue.prototype.$authModal = new Vue({
  render: h => h(AuthenticationModal)
}).$mount();

new Vue({
  i18n,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app');

// console.log('Authentication modal registered:', Vue.prototype.$authModal);
